import React, { useEffect, useRef, useState } from "react";
import {
  FaComment,
  FaImage,
  FaPaperPlane,
  FaRedo,
  FaSmile,
  FaThumbsUp,
} from "react-icons/fa";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkIcon from "@mui/icons-material/Link";
import SendIcon from "@mui/icons-material/Send";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import DeleteIcon from "@mui/icons-material/Delete";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import {
  MdVideocam,
  MdLocationOn,
  MdEvent,
  MdLink,
  MdClose,
  MdReply,
  MdThumbUp,
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
} from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import {
  format,
  parse,
  isBefore,
  isWithinInterval,
  isToday,
  isTomorrow,
  set,
} from "date-fns";
import { PiDotsThree } from "react-icons/pi";
import {
  FaBookmark,
  FaRegBookmark,
  FaLink,
  FaEdit,
  FaTrash,
  FaCommentSlash,
} from "react-icons/fa";
import EmojiPicker from "emoji-picker-react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import InviteEventConnectionModal from "../../Modals/InviteEventConnectionModal";
import ManageAttendeesModal from "../../Modals/ManageAttendeesModal";
import Swal from 'sweetalert2';

const formatEventDate = (startDate, startTime, endDate, endTime, timezone) => {
  try {
    const normalizeTime = (time) => {
      if (!time) return "00:00:00";
      if (!time.includes(":")) return `${time}:00:00`;
      if (time.split(":").length === 2) return `${time}:00`;
      return time;
    };

    const normalizedStartTime = normalizeTime(startTime);
    const normalizedEndTime = normalizeTime(endTime);

    if (!startDate || !endDate || !normalizedStartTime || !normalizedEndTime) {
      throw new Error("Missing date/time values");
    }

    const startDateTime = parse(
      `${startDate} ${normalizedStartTime}`,
      "yyyy-MM-dd HH:mm:ss",
      new Date()
    );
    const endDateTime = parse(
      `${endDate} ${normalizedEndTime}`,
      "yyyy-MM-dd HH:mm:ss",
      new Date()
    );

    if (isNaN(startDateTime) || isNaN(endDateTime)) {
      throw new Error("Invalid date/time values");
    }

    const now = new Date();
    let status = "";
    let statusDisplay = "";

    if (isBefore(endDateTime, now)) {
      status = "Ended";
      statusDisplay = "Event ended";
    } else if (
      isWithinInterval(now, { start: startDateTime, end: endDateTime })
    ) {
      status = "Happening";
      statusDisplay = "Happening now";
    } else if (isToday(startDateTime)) {
      status = "Today";
      statusDisplay = `Today at ${format(startDateTime, "h:mm a")}`;
    } else if (isTomorrow(startDateTime)) {
      status = "Tomorrow";
      statusDisplay = `Tomorrow at ${format(startDateTime, "h:mm a")}`;
    } else {
      status = "Upcoming";
      statusDisplay = `Upcoming on ${format(startDateTime, "MMM d, yyyy")}`;
    }

    const start = new Date(`${startDate}T${normalizedStartTime}`);
    const end = new Date(`${endDate}T${normalizedEndTime}`);

    if (isNaN(start) || isNaN(end)) {
      throw new Error("Invalid date/time values for timezone formatting");
    }

    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone || "UTC",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    let formattedDateTime = "";
    if (startDate !== endDate) {
      formattedDateTime = `${formatter.format(start)} - ${formatter.format(
        end
      )}`;
    } else {
      const formattedDate = new Intl.DateTimeFormat("en-US", {
        timeZone: timezone || "UTC",
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(start);

      const formattedStartTime = new Intl.DateTimeFormat("en-US", {
        timeZone: timezone || "UTC",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }).format(start);

      const formattedEndTime = new Intl.DateTimeFormat("en-US", {
        timeZone: timezone || "UTC",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      }).format(end);

      formattedDateTime = `${formattedDate}, ${formattedStartTime} - ${formattedEndTime}`;
    }

    return {
      status,
      statusDisplay,
      formattedDateTime,
      startDateTime,
      endDateTime,
    };
  } catch (error) {
    console.error("Error formatting event date:", error);
    return {
      status: "Unknown",
      statusDisplay: "Invalid Date",
      formattedDateTime: "Invalid Date",
      startDateTime: null,
      endDateTime: null,
    };
  }
};

const EventDetails = () => {
  const { slug } = useParams();
  const [activeTab, setActiveTab] = useState("details");
  const [showShareDropdown, setShowShareDropdown] = useState(false);
  const [showManageDropdown, setShowManageDropdown] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const shareDropdownRef = useRef(null);
  const manageDropdownRef = useRef(null);
  const shareButtonRef = useRef(null);
  const manageButtonRef = useRef(null);
  const [eventData, setEventData] = useState({});
  const [showComments, setShowComments] = useState(true);
  const [showAllComments, setShowAllComments] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [showCommentForm, setShowCommentForm] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showMoreComments, setShowMoreComments] = useState(false);
  const [comments, setComments] = useState([]);
  const [postData, setPostData] = useState({});
  const [showOptions, setShowOptions] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isSaved, setIsSaved] = useState();
  const [newComment, setNewComment] = useState("");
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [showAllReplies, setShowAllReplies] = useState({});
  const [isLiked, setIsLiked] = useState();
  const [likes, setLikes] = useState();
  const [showReplyEmojiPicker, setShowReplyEmojiPicker] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [attendees, setAttendees] = useState([]);
  const [showConnectionModal, setShowConnectionModal] = useState(false);
  const [showAttendeeModal, setShowAttendeeModal] = useState(false);

  const [connections, setConnections] = useState([]);
  const [invitedEventUsers, setInvitedEventUsers] = useState([]);
  const [eventAttendeeUsers, setEventAttendeeUsers] = useState([]);
  const navigate = useNavigate();
  const EmojiPickerWrapper = ({ onEmojiSelect, onClose, positionClass }) => {
    const pickerRef = useRef(null);
    

    useEffect(() => {
      const handleClickOutside = (e) => {
        if (pickerRef.current && !pickerRef.current.contains(e.target)) {
          onClose();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    return (
      <div ref={pickerRef} className={`absolute z-50 ${positionClass}`}>
        <EmojiPicker
          onEmojiClick={(emojiData) => {
            onEmojiSelect(emojiData.emoji);
            onClose();
          }}
          width={300}
          height={350}
        />
      </div>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showShareDropdown &&
        shareDropdownRef.current &&
        !shareDropdownRef.current.contains(event.target) &&
        !shareButtonRef.current.contains(event.target)
      ) {
        setShowShareDropdown(false);
      }

      if (
        showManageDropdown &&
        manageDropdownRef.current &&
        !manageDropdownRef.current.contains(event.target) &&
        !manageButtonRef.current.contains(event.target)
      ) {
        setShowManageDropdown(false);
      }

      
    };

    if (showShareDropdown || showManageDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showShareDropdown, showManageDropdown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getEventDetails();
    getComments();
    getAttendess();
    getConnections();
    getInvitedEventUsers();
  }, []);

  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)}h ago`;
    return `${Math.floor(diffInSeconds / 86400)}d ago`;
  };

  const getConnections = async () => {
    try {
      const response = await axios.get(BaseUrl + `getconnections/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setConnections(response.data.data.connections); 
    } catch (error) {
      console.error("Error fetching connections:", error);
    }
  };

  const getInvitedEventUsers = async () => {
    try {
      const response = await axios.get(BaseUrl + `invitedEventUser/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      setInvitedEventUsers(response.data.data.Invites); 
      setEventAttendeeUsers(response.data.data.Attendees); 
    } catch (error) {
      console.error("Error fetching connections:", error);
    }
  }
  const getEventDetails = async () => {
    try {
      setIsloading(true);
      const response = await axios.get(`${BaseUrl}event/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      if (response.data.status === 200) {
        setEventData(response.data.data);
        setIsloading(false);
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
      setIsloading(false);
    }
  };

  const getComments = async () => {
    try {
      const response = await axios.get(`${BaseUrl}getsingleeventpost/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      if (response.data.status === 200) {
        setPostData(response.data.data);
        setComments(response.data.data.comments);
        setIsLiked(response.data.data.has_liked);
        setIsSaved(response.data.data.is_saved);
        setLikes(response.data.data.likes);
        setCurrentUser({
          id: response.data.data.current_user.id,
          profile_image: response.data.data.current_user.profile,
          name: response.data.data.current_user.name,
        });
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  const getAttendess = async () => {
    try {
      const response = await axios.get(`${BaseUrl}getuserbyevent/${slug}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      if (response.data.status === 200) {
        setAttendees(response.data.data.attendees);
      }
    } catch (error) {
      console.error("Error fetching attendees:", error);
    }
  }

  const handleAttend = async () => {
    try {
      const formData = new FormData();
      formData.append("event_id", eventData.id);

      const response = await axios.post(`${BaseUrl}attend`, formData, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.status === 200) {
        setEventData(response.data.data);
        Swal.fire({
          toast: true,
          position: "bottom-start",
          icon: "success",
          title: "Thank you for attending the event!",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error attending event:", error);
    }
  };

  const handleAcceptInvite = async (id) => {
    try {
      const response = await axios.post(
        BaseUrl + `acceptInvite/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.data.status === 200) {
        setEventData(response.data.data);

        Swal.fire({
          toast: true,
          position: "bottom-start",
          icon: "success",
          title: "Event invite accepted successfully!",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Join request failed:", error);
    }
  };

  const handleLike = async (postId) => {
    try {
      const prevLiked = isLiked;

      setIsLiked(!prevLiked);
      setLikes(prevLiked ? likes - 1 : likes + 1);

      const endpoint = prevLiked
        ? `unlikepost/${postId}`
        : `likepost/${postId}`;

      const response = await axios.post(
        BaseUrl + endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error updating like:", error);
      swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update like status",
      });
    }
  };

  const handleCommentLike = async (liked, commentId) => {
    const previousComments = [...comments];
    try {
      const updatedComments = comments.map((comment) =>
        comment.comment_id === commentId
          ? {
              ...comment,
              has_liked_comment: !liked,
              likes: liked ? comment.likes - 1 : comment.likes + 1,
            }
          : comment
      );
      setComments(updatedComments);

      const endpoint = liked
        ? `unlikecomment/${commentId}`
        : `likecomment/${commentId}`;

      const response = await axios.post(
        `${BaseUrl}${endpoint}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
    } catch (error) {
      console.error("Error updating comment like:", error);

      setComments(previousComments);

      swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update comment like status",
      });
    }
  };

  const generateTempId = () =>`temp-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

  const handleCommentSubmit = async (e, postId) => {
    e.preventDefault();
    if (!commentText) return;
    const formData = new FormData();
    formData.append("comment", commentText);
    const tempId = generateTempId();
    const tempComment = {
      comment: commentText,
      comment_id: tempId,
      comment_post_id: postId,
      comment_user_id: currentUser.id,
      comment_user_name: currentUser.name,
      comment_user_profile: currentUser.profile_image,
      created_at: new Date().toISOString(),
      likes_count: 0,
      has_liked_comment: false,
      replies: [],
    };

    setComments((prevComments) => [tempComment, ...prevComments]);
    setCommentText("");

    try {
      const response = await axios.post(
        BaseUrl + `comment/${postId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        const realCommentId = response.data.data.id;

        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment.comment_id === tempId
              ? { ...comment, comment_id: realCommentId }
              : comment
          )
        );
      }
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  const handleReplySubmit = async (e, parentCommentId, postId) => {
    e.preventDefault();
    if (!replyText.trim()) return;
    const tempId = generateTempId();
    const tempReply = {
      comment: replyText,
      comment_id: tempId, 
      comment_parent_id: parentCommentId,
      comment_post_id: postId,
      comment_user_id: currentUser.id,
      comment_user_name: currentUser.name,
      comment_user_profile: currentUser.profile_image,
      created_at: new Date().toISOString(),
      comment_likes: 0,
      has_liked_comment: false,
      replies: [],
    };
  
    setComments((prevComments) =>
      prevComments.map((comment) => {
        if (comment.comment_id === parentCommentId) {
          return {
            ...comment,
            replies: [...comment.replies, tempReply], 
          };
        }
        return comment;
      })
    );
  
    setReplyText("");
    setReplyingTo(null);
  
    try {
      const formData = new FormData();
      formData.append("comment", replyText);
  
      const response = await axios.post(
        BaseUrl + `commentreply/${postId}/${parentCommentId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
  
      if (response.data.status === 200 && response.data.data) {
        const realReplyId = response.data.data.id;
  
        
        setComments((prevComments) =>
          prevComments.map((comment) => {
            if (comment.comment_id === parentCommentId) {
              return {
                ...comment,
                replies: comment.replies.map((reply) =>
                  reply.comment_id === tempId
                    ? { ...reply, comment_id: realReplyId }
                    : reply
                ),
              };
            }
            return comment;
          })
        );
      }
    } catch (error) {
      console.log("Error submitting reply:", error);
    }
  };
  
  const handleToggleSaveUnsave = async (id) => {
    setShowOptions(false);
    const prevSavedState = isSaved;
    setIsSaved(!isSaved);
  
    try {
      const endpoint = isSaved ? "unsavepost" : "savepost";
      const response = await axios.post(
        `${BaseUrl}${endpoint}`,
        {
          saved_type: "event",
          savable_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
  
      if (response.data.status === 500) {
        setIsSaved(prevSavedState); 
      }
    } catch (error) {
      setIsSaved(prevSavedState); 
      console.error("Save/Unsave failed:", error);
    }
  };

  const DeleteEvent = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you really want to delete this event?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    });
  
    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          `${BaseUrl}deleteEvent/${slug}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("token")}`,
            },
          }
        );
        if (response.data.status === 200) {
          Swal.fire({
            toast: true,
            position: 'bottom-start',
            icon: 'success',
            title: 'Event deleted successfully',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          navigate("/events/allevents");
        }
      } catch (error) {
        console.error("Error deleting event:", error);
        Swal.fire('Error!', 'Something went wrong while deleting the event.', 'error');
      }
    }
  };
  const canInvite = new Date(`${eventData.start_date}T${eventData.start_time}`) < new Date();



  return (
    <>
      {isloading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-12">
          <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
            <div className="w-full lg:w-3/4 min-h-screen">
              <div className="bg-white border border-gray-200 rounded-lg mt-5">
                <div className="relative">
                  {eventData.image ? (
                    <img
                      className="w-full h-60 object-cover"
                      src={eventData.image}
                      alt="Event Banner"
                    />
                  ) : (
                    <img
                      className="w-full h-60 object-cover"
                      src="/Images/Events/dummy-img.png"
                      alt="Event Banner"
                    />
                  )}

                  <div className="p-5">
                    {eventData.start_date &&
                      eventData.start_time &&
                      eventData.end_date &&
                      eventData.end_time && (
                        <span className="flex items-center gap-1 text-[12px]">
                          {formatEventDate(
                            eventData.start_date,
                            eventData.start_time,
                            eventData.end_date,
                            eventData.end_time,
                            eventData.timezone
                          ).status === "Ended" && (
                            <i className="fas fa-info-circle text-gray-500"></i>
                          )}
                          <span
                            className={`${
                              formatEventDate(
                                eventData.start_date,
                                eventData.start_time,
                                eventData.end_date,
                                eventData.end_time,
                                eventData.timezone
                              ).status === "Happening"
                                ? "text-orange-500 text-md font-medium"
                                : "text-gray-500"
                            }`}
                          >
                            {
                              formatEventDate(
                                eventData.start_date,
                                eventData.start_time,
                                eventData.end_date,
                                eventData.end_time,
                                eventData.timezone
                              ).statusDisplay
                            }
                          </span>
                        </span>
                      )}
                    <h2 className="text-xl font-bold">
                      {eventData.event_name}
                    </h2>
                    <p className="text-md black">
                      Event by{" "}
                      <span className="font-normal text-gray-600">
                        {eventData.created_by_name || "Unknown Organizer"}
                      </span>
                    </p>
                    <p className="flex items-center gap-1 text-sm text-gray-500 my-1">
                      <MdEvent size={20} className="text-gray-700" />
                      {eventData.start_date &&
                        eventData.start_time &&
                        eventData.end_date &&
                        eventData.end_time &&
                        formatEventDate(
                          eventData.start_date,
                          eventData.start_time,
                          eventData.end_date,
                          eventData.end_time,
                          eventData.timezone
                        ).formattedDateTime}
                    </p>
                    {eventData.event_type === "online" ? (
                      <p className="flex items-center gap-1 text-sm text-gray-500 my-1">
                        <MdVideocam size={20} className="text-gray-700" />{" "}
                        Online
                      </p>
                    ) : (
                      <p className="flex items-center gap-1 text-sm text-gray-500 my-1">
                        <MdLocationOn size={20} className="text-gray-700" />
                        {eventData.address}
                        {eventData.venue && `, ${eventData.venue}`}
                      </p>
                    )}
                    {eventData.external_event_link && (
                      <p className="flex items-center gap-1 text-sm text-blue-600 underline cursor-pointer my-1">
                        <MdLink size={20} className="text-gray-700" />
                        <a
                          href={eventData.external_event_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {eventData.external_event_link}
                        </a>
                      </p>
                    )}
                    <p className="text-sm text-gray-500 my-1">
                      👤 {eventData.attendee_count || 0} attendee
                      {eventData.attendee_count !== 1 ? "s" : ""}
                    </p>
                  </div>

                  <div className="flex items-center gap-2 px-5 pb-5">
                    {eventData.is_invited ? (
                      <button
                        className="bg-blue-600 text-white px-4 py-1 rounded-full flex items-center"
                        onClick={() => handleAcceptInvite(eventData.id)}
                      >
                        Accept
                      </button>
                    ) : (
                      !eventData.is_attending && (
                        <button
                          className="bg-blue-600 text-white px-4 py-1 rounded-full flex items-center"
                          onClick={handleAttend}
                        >
                          Attend
                        </button>
                      )
                    )}

                    <div className="relative">
                      <button
                        ref={shareButtonRef}
                        onClick={() => setShowShareDropdown(!showShareDropdown)}
                        className="bg-blue-600 text-white px-4 py-1 rounded-full flex items-center"
                      >
                        Share ▼
                      </button>
                      {showShareDropdown && (
                        <div
                          ref={shareDropdownRef}
                          className="absolute bg-white border shadow-md rounded-b-md rounded-l-md mt-1 p-2 w-48 z-50"
                        >
                          <p className="font-semibold text-sm">
                            Share on LinkedIn
                          </p>

                          {!canInvite && eventData.is_organizer && (
                            <button
                              className="text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100"
                              onClick={() =>
                                setShowConnectionModal(!showConnectionModal)
                              }
                            >
                              <MailOutlineIcon
                                size={16}
                                className="text-gray-700"
                              />{" "}
                              Invite
                            </button>
                          )}

                          <button className="text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100">
                            <ModeEditIcon size={16} className="text-gray-700" />{" "}
                            Repost to Feed
                          </button>
                          <button className="text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100">
                            <SendIcon size={16} className="text-gray-700" />{" "}
                            Send in a message
                          </button>
                          <hr className="my-1" />
                          <p className="font-semibold text-sm">Other options</p>
                          <button
                            className="flex items-center gap-1 text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100"
                            onClick={() => {
                              navigator.clipboard.writeText(
                                window.location.href
                              );

                              Swal.fire({
                                toast: true,
                                position: "bottom-start",
                                icon: "success",
                                title: "Link copied to clipboard",
                                showConfirmButton: false,
                                timer: 1500,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                  toast.addEventListener(
                                    "mouseenter",
                                    Swal.stopTimer
                                  );
                                  toast.addEventListener(
                                    "mouseleave",
                                    Swal.resumeTimer
                                  );
                                },
                              });
                              setShowShareDropdown(false);
                            }}
                          >
                            <LinkIcon size={16} className="text-gray-700" />{" "}
                            Copy link
                          </button>
                          <button
                            className="flex items-center gap-1 text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100"
                            onClick={() => {
                              const text =
                                encodeURIComponent("Check this out!");
                              const url = encodeURIComponent(
                                window.location.href
                              );
                              window.open(
                                `https://twitter.com/intent/tweet?text=${text}&url=${url}`,
                                "_blank"
                              );
                              setShowShareDropdown(false);
                            }}
                          >
                            <XIcon size={16} className="text-gray-700" />{" "}
                            Twitter
                          </button>
                          <button
                            className="flex items-center gap-1 text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100"
                            onClick={() => {
                              const url = encodeURIComponent(
                                window.location.href
                              );
                              window.open(
                                `https://www.facebook.com/sharer/sharer.php?u=${url}`,
                                "_blank"
                              );
                              setShowShareDropdown(false);
                            }}
                          >
                            <FacebookIcon size={16} className="text-gray-700" />{" "}
                            Facebook
                          </button>
                        </div>
                      )}
                    </div>

                    {eventData.is_organizer && (
                      <div className="relative">
                        <button
                          ref={manageButtonRef}
                          className="bg-gray-300 text-black px-4 py-1 rounded-full"
                          onClick={() =>
                            setShowManageDropdown(!showManageDropdown)
                          }
                        >
                          Manage ▼
                        </button>
                        {showManageDropdown && (
                          <div
                            ref={manageDropdownRef}
                            className="absolute bg-white border shadow-md rounded-b-md rounded-l-md mt-1 p-2 w-48 z-50"
                          >
                            <button
                              className="flex items-center gap-1 text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100"
                              onClick={() => {
                                setShowAttendeeModal(!showAttendeeModal);
                              }}
                            >
                              <PeopleAltIcon
                                size={16}
                                className="text-gray-700"
                              />
                              Manage attendees
                            </button>
                            <button
                              className="flex items-center gap-1 text-sm text-gray-700 w-full text-left p-1 hover:bg-gray-100"
                              onClick={() => {
                                DeleteEvent();
                              }}
                            >
                              <DeleteIcon size={16} className="text-gray-700" />
                              Delete event
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="border-y flex justify-start gap-4 px-4 overflow-x-auto">
                  {[
                    { label: "Details", key: "details" },
                    { label: "Comments", key: "comments" },
                    { label: "Networking", key: "networking" },
                    eventData.is_organizer && {
                      label: "Analytics",
                      key: "analytics",
                    },
                  ]
                    .filter(Boolean)
                    .map((tab) => (
                      <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        className={`py-3 px-5 text-base font-medium whitespace-nowrap border-b-4 transition-colors duration-200 ${
                          activeTab === tab.key
                            ? "border-blue-600 text-blue-600"
                            : "border-transparent text-gray-600 hover:text-blue-500"
                        }`}
                      >
                        {tab.label}
                      </button>
                    ))}
                </div>
              </div>

              <div>
                {activeTab === "details" && (
                  <>
                    <div className="bg-white shadow-lg rounded-lg mt-5 p-5">
                      <h3 className="text-xl font-semibold">About</h3>
                      <p>
                        {eventData.description || "No description available."}
                      </p>
                    </div>
                    {/* <div className="bg-white shadow-lg rounded-lg mt-5 p-5">
                      <h3 className="text-xl font-semibold">Speakers</h3>
                      <p className="text-gray-500 text-sm">
                        Pending speakers are visible only to you
                      </p>
                      {(eventData.speakers || []).length > 0 ? (
                        eventData.speakers.map((speaker, index) => (
                          <div key={index} className="grid grid-cols-3">
                            <div
                              
                              className=" border border-gray-200 w-56 bg-white rounded-lg mt-2"
                            >
                              <div className="relative">
                                <img
                                  src={
                                    speaker.cover_image ||
                                    "/Images/cover-img.jpg"
                                  }
                                  alt={`${speaker.name} background`}
                                  className="w-56 h-18 object-cover rounded-t-lg"
                                />
                                <div className="absolute bottom-3 left-4 transform translate-y-1/2">
                                  <img
                                    src={
                                      speaker.profile_image ||
                                      "/Images/user-img.jpg"
                                    }
                                    alt={`${speaker.name} profile`}
                                    className="size-20 rounded-full border-4 border-white"
                                  />
                                </div>
                              </div>
                              <div className="py-8 px-6">
                                <h1 className="text-xl font-bold">
                                  {speaker.name}
                                </h1>
                                <p className="text-sm text-gray-700">
                                  {speaker.headline}
                                </p>
                                {speaker.status === "pending" && (
                                  <p className="text-[12px] text-red-500 mt-2">
                                    Pending
                                  </p>
                                )}
                                {speaker.is_connected ? (
                                  <button className="bg-gray-100 w-full text-center text-md py-1 px-4 font-medium rounded-full mt-4 border border-gray-600">
                                    Following
                                  </button>
                                ) : (
                                  <button className="bg-gray-100 w-full text-center text-md py-1 px-4 font-medium rounded-full mt-4 border border-gray-600">
                                    Follow
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-gray-600 mt-2">
                          No speakers listed.
                        </p>
                      )}
                    </div> */}
                    <div className="bg-white shadow-lg rounded-lg mt-5 p-5">
                      <h3 className="text-xl font-semibold">Speakers</h3>
                      <p className="text-gray-500 text-sm">
                        Pending speakers are visible only to you
                      </p>
                      {(eventData.speakers || []).length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                          {eventData.speakers
                            .slice(0, 4)
                            .map((speaker, index) => (
                              <div
                                key={index}
                                className="border border-gray-200 w-56 bg-white rounded-lg"
                              >
                                <div className="relative">
                                  <img
                                    src={
                                      speaker.cover_image ||
                                      "/Images/cover-img.jpg"
                                    }
                                    alt={`${speaker.name} background`}
                                    className="w-56 h-16 object-cover rounded-t-lg"
                                  />
                                  <div className="absolute bottom-3 left-4 transform translate-y-1/2">
                                    <img
                                      src={
                                        speaker.profile_image ||
                                        "/Images/user-img.jpg"
                                      }
                                      alt={`${speaker.name} profile`}
                                      className="size-20 rounded-full border-4 border-white"
                                    />
                                  </div>
                                </div>
                                <div className="py-8 px-6">
                                  <h1 className="text-xl font-bold">
                                    {speaker.name}
                                  </h1>
                                  <p className="text-sm text-gray-700">
                                    {speaker.headline || "No headline"}
                                  </p>
                                  {speaker.status === "pending" && (
                                    <p className="text-[12px] text-red-500 mt-2">
                                      Pending
                                    </p>
                                  )}
                                  {speaker.is_connected ? (
                                    <button className="bg-gray-100 w-full text-center text-md py-1 px-4 font-medium rounded-full mt-4 border border-gray-600">
                                      Following
                                    </button>
                                  ) : (
                                    <button className="bg-gray-100 w-full text-center text-md py-1 px-4 font-medium rounded-full mt-4 border border-gray-600">
                                      Follow
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      ) : (
                        <p className="text-gray-600 mt-2">
                          No speakers listed.
                        </p>
                      )}
                    </div>
                  </>
                )}

                {activeTab === "comments" && (
                  <div className="bg-white shadow-lg rounded-lg mt-5 p-5">
                    <h3 className="text-xl font-semibold">Comments</h3>
                    <div className="mt-4">
                      <div className="relative flex items-start justify-between space-x-3">
                        <div className="flex items-center space-x-3">
                          <div className="w-12 h-12 rounded-full overflow-hidden">
                            {postData.user.profile ? (
                              <img
                                src={postData.user.profile}
                                alt={postData.user.name}
                                className="w-full h-full object-cover border border-gray-200 rounded-full"
                              />
                            ) : (
                              <div className="w-full h-full bg-blue-500 flex items-center justify-center text-white font-semibold text-lg">
                                {postData.user.name.charAt(0).toUpperCase()}
                              </div>
                            )}
                          </div>
                          <div>
                            <h3 className="font-semibold">
                              {postData.user.name}
                            </h3>
                            <p className="text-xs text-gray-500">
                              {postData.user.headline}
                            </p>
                            <p className="text-xs text-gray-500">
                              {new Date(
                                postData.created_at
                              ).toLocaleDateString()}
                              <span className="mx-1">•</span>
                              <span>
                                {postData.type === "event" ? "Event" : "Post"}
                              </span>
                            </p>
                          </div>
                        </div>

                        <div className="relative" ref={dropdownRef}>
                          <PiDotsThree
                            className="text-2xl cursor-pointer hover:text-gray-700"
                            onClick={() => setShowOptions((prev) => !prev)}
                          />

                          {showOptions && (
                            <div className="absolute bg-white border border-gray-300 shadow-lg rounded-b-lg rounded-tl-lg z-50 mt-0 w-72 right-1 overflow-hidden">
                              <button
                                className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
                                onClick={() =>
                                  handleToggleSaveUnsave(postData.id)
                                }
                              >
                                {isSaved ? <FaBookmark /> : <FaRegBookmark />}
                                {isSaved ? "Unsave" : "Save"}
                              </button>

                              <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
                                <FaLink />
                                Copy Link to Post
                              </button>

                              <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
                                <FaEdit />
                                Edit Post
                              </button>

                              <button
                                className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors"
                                onClick={() => handleDeletePost(postData.id)}
                              >
                                <FaTrash />
                                Delete Post
                              </button>

                              <button className="flex items-center gap-3 w-full px-4 py-3 text-gray-800 text-md font-medium hover:bg-gray-100 transition-colors">
                                <FaCommentSlash />
                                Disable Comments on this Post
                              </button>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="border-b border-gray-200">
                        <p className="mt-4">{postData.content}</p>
                        <div className="my-2 flex items-center justify-between text-sm text-gray-500 space-x-4  ">
                          <span>{likes} likes</span>
                          <span>
                            {comments.length}{" "}
                            {comments.length === 1 ? "Comment" : "Comments"}{" "}
                          </span>
                        </div>
                      </div>

                      <div className="flex justify-start items-center gap-8 mt-4 text-gray-600 text-sm mx-2">
                        <button
                          className={`cursor-pointer flex items-center space-x-2 hover:text-blue-500 ${
                            isLiked ? "text-blue-500" : ""
                          }`}
                          onClick={() => handleLike(postData.id)}
                        >
                          <FaThumbsUp /> <span>Like</span>
                        </button>
                        <button
                          className="flex items-center space-x-2 hover:text-blue-500"
                          onClick={() => {
                            setShowComments(!showComments),
                              setShowAllComments(false);
                          }}
                        >
                          <FaComment /> <span>Comment</span>
                        </button>
                        {/* <button className="flex items-center space-x-2 hover:text-blue-500">
                          <FaRedo /> <span>Repost</span>
                        </button>
                        <button className="flex items-center space-x-2 hover:text-blue-500">
                          <FaPaperPlane /> <span>Send</span>
                        </button> */}
                      </div>

                      <div className="border-gray-200">
                        <div className="mt-4">
                          {showComments && (
                            <div className="mt-4">
                              <div className="border-t py-4">
                                < form
                                  onSubmit={(e) =>
                                    handleCommentSubmit(e, postData.id)
                                  }
                                  className="relative flex items-start gap-3 mb-4"
                                >
                                  {postData.user.profile ? (
                                    <img
                                      src={postData.user.profile}
                                      alt="user"
                                      className="w-8 h-8 rounded-full object-cover"
                                    />
                                  ) : (
                                    <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-sm">
                                      {postData.user.name
                                        ?.charAt(0)
                                        .toUpperCase()}
                                    </div>
                                  )}
                                  <div className="flex-1">
                                    <div className="flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
                                      <input
                                        type="text"
                                        value={commentText}
                                        onChange={(e) =>
                                          setCommentText(e.target.value)
                                        }
                                        placeholder="Add a comment..."
                                        className="flex-1 outline-none bg-transparent"
                                      />
                                      <div className="flex items-center gap-2">
                                        <button
                                          type="button"
                                          onClick={() =>
                                            setShowEmojiPicker(!showEmojiPicker)
                                          }
                                          className="text-gray-500 hover:text-gray-700"
                                        >
                                          😊
                                        </button>
                                        {commentText.trim() && (
                                          <button
                                            type="submit"
                                            className="text-blue-500 font-medium"
                                          >
                                            Post
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                    {showEmojiPicker && (
                                      <EmojiPickerWrapper
                                        onEmojiSelect={(emoji) =>
                                          setCommentText((prev) => prev + emoji)
                                        }
                                        onClose={() =>
                                          setShowEmojiPicker(false)
                                        }
                                        positionClass="bottom-12 right-0"
                                      />
                                    )}
                                  </div>
                                </form>
                                <div className="flex items-center justify-between mb-3 px-2">
                                  <div className="flex items-center">
                                    <h3 className="font-medium text-gray-800 text-[15px]">
                                      {comments.length}{" "}
                                      {comments.length === 1
                                        ? "Comment"
                                        : "Comments"}
                                    </h3>
                                    {comments.length > 2 &&
                                      !showAllComments && (
                                        <span className="ml-2 text-xs text-gray-500">
                                          ({comments.length - 2} hidden)
                                        </span>
                                      )}
                                  </div>
                                  <button
                                    onClick={() => {
                                      setShowComments(!showComments),
                                        setShowAllComments(false);
                                    }}
                                    className="text-sm text-gray-600 hover:text-gray-800 flex items-center group"
                                  >
                                    <span className="group-hover:bg-gray-100 p-1.5 rounded-full">
                                      <MdClose className="text-lg" />
                                    </span>
                                  </button>
                                </div>

                                <div className="space-y-4">
                                  {comments
                                    .slice(
                                      0,
                                      showAllComments ? comments.length : 2
                                    )
                                    .map((comment) => (
                                      <div
                                        key={comment.comment_id}
                                        className="flex gap-3"
                                      >
                                        <div className="flex-shrink-0">
                                          {comment.comment_user_profile ? (
                                            <img
                                              src={comment.comment_user_profile}
                                              alt={comment.comment_user_name}
                                              className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                            />
                                          ) : (
                                            <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                              {comment.comment_user_name?.[0]?.toUpperCase()}
                                            </div>
                                          )}
                                        </div>

                                        <div className="flex-1">
                                          <div className="bg-gray-50 rounded-2xl p-3">
                                            <div className="flex items-center justify-between">
                                              <div className="flex items-center gap-1">
                                                <p className="font-medium text-sm font-semibold text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                                  {comment.comment_user_name ||
                                                    "User"}
                                                </p>
                                                {comment.is_author && (
                                                  <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                                    Author
                                                  </span>
                                                )}
                                              </div>
                                              <span className="text-xs text-gray-500">
                                                {formatTimeAgo(
                                                  comment.created_at
                                                )}
                                              </span>
                                            </div>

                                            <p className="text-sm text-gray-800 mt-1 whitespace-pre-line">
                                              {comment.comment}
                                            </p>

                                            <div className="flex items-center mt-2 text-xs text-gray-500">
                                              <button
                                                className={`flex items-center gap-1 hover:text-blue-600 ${
                                                  comment.has_liked_comment
                                                    ? "text-blue-600"
                                                    : ""
                                                }`}
                                                onClick={() =>
                                                  handleCommentLike(
                                                    comment.has_liked_comment,
                                                    comment.comment_id
                                                  )
                                                }
                                              >
                                                <i
                                                  className={`fas fa-thumbs-up ${
                                                    comment.has_liked_comment
                                                      ? "text-blue-500"
                                                      : ""
                                                  }`}
                                                ></i>
                                                {comment.comment_likes > 0 && (
                                                  <span>
                                                    {comment.comment_likes}
                                                  </span>
                                                )}
                                                <span>Like</span>
                                              </button>

                                              <span className="mx-2 text-gray-800">
                                                |
                                              </span>

                                              <button
                                                className="flex items-center gap-1 hover:text-blue-600"
                                                onClick={() =>
                                                  setReplyingTo(
                                                    replyingTo ===
                                                      comment.comment_id
                                                      ? null
                                                      : comment.comment_id
                                                  )
                                                }
                                              >
                                                <MdReply className="text-base" />
                                                <span className="ml-1">
                                                  Reply
                                                </span>
                                                {comment.replies &&
                                                  comment.replies.length >
                                                    0 && (
                                                    <>
                                                      <span className="mx-1">
                                                        •
                                                      </span>
                                                      <span>
                                                        {comment.replies.length}
                                                      </span>
                                                      {comment.replies
                                                        .length === 1
                                                        ? "reply"
                                                        : "replies"}
                                                    </>
                                                  )}
                                              </button>
                                            </div>
                                          </div>

                                          {comment.replies &&
                                            comment.replies.length > 0 && (
                                              <div className="mt-2 ml-2 pl-4 border-l-2 border-gray-200">
                                                {comment.replies
                                                  .slice(
                                                    0,
                                                    showAllReplies[
                                                      comment.comment_id
                                                    ]
                                                      ? comment.replies.length
                                                      : 2
                                                  )
                                                  .map((reply) => (
                                                    <div
                                                      key={reply.comment_id}
                                                      className="flex gap-3 mt-3"
                                                    >
                                                      <div className="flex-shrink-0">
                                                        {reply.comment_user_profile ? (
                                                          <img
                                                            src={
                                                              reply.comment_user_profile
                                                            }
                                                            alt={
                                                              reply.comment_user_name
                                                            }
                                                            className="w-8 h-8 rounded-full object-cover border border-gray-200"
                                                          />
                                                        ) : (
                                                          <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-semibold text-sm border border-gray-200">
                                                            {reply.comment_user_name?.[0]?.toUpperCase()}
                                                          </div>
                                                        )}
                                                      </div>

                                                      <div className="flex-1">
                                                        <div className="bg-gray-50 rounded-2xl p-3">
                                                          <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-1">
                                                              <p className="font-medium font-semibold text-sm text-gray-900 hover:underline hover:text-blue-600 cursor-pointer">
                                                                {reply.comment_user_name ||
                                                                  "User"}
                                                              </p>
                                                              {reply.is_author && (
                                                                <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded-full">
                                                                  Author
                                                                </span>
                                                              )}
                                                            </div>
                                                            <span className="text-xs text-gray-500">
                                                              {formatTimeAgo(
                                                                reply.created_at
                                                              )}
                                                            </span>
                                                          </div>

                                                          <p className="text-sm text-gray-800 mt-1">
                                                            {reply.comment}
                                                          </p>

                                                          <div className="flex items-center mt-2 text-xs text-gray-500 space-x-4">
                                                            <button
                                                              className={`flex items-center gap-1 hover:text-blue-600 ${
                                                                reply.has_liked_comment
                                                                  ? "text-blue-600"
                                                                  : ""
                                                              }`}
                                                              onClick={() =>
                                                                handleCommentLike(
                                                                  reply.has_liked_comment,
                                                                  reply.comment_id
                                                                )
                                                              }
                                                            >
                                                              <MdThumbUp className="icon" />
                                                              {reply.comment_likes >
                                                                0 && (
                                                                <span>
                                                                  {
                                                                    reply.comment_likes
                                                                  }
                                                                </span>
                                                              )}
                                                              <span>Like</span>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ))}

                                                {comment.replies.length > 2 && (
                                                  <button
                                                    onClick={() =>
                                                      setShowAllReplies(
                                                        (prev) => ({
                                                          ...prev,
                                                          [comment.comment_id]:
                                                            !prev[
                                                              comment.comment_id
                                                            ],
                                                        })
                                                      )
                                                    }
                                                    className="w-full text-left text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors mt-2"
                                                  >
                                                    <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                                                      {showAllReplies[
                                                        comment.comment_id
                                                      ] ? (
                                                        <>
                                                          <MdKeyboardArrowUp className="mr-1 text-lg" />
                                                          Collapse replies
                                                        </>
                                                      ) : (
                                                        <>
                                                          <MdKeyboardArrowDown className="mr-1 text-lg" />
                                                          See{" "}
                                                          {comment.replies
                                                            .length - 2}{" "}
                                                          more{" "}
                                                          {comment.replies
                                                            .length -
                                                            2 ===
                                                          1
                                                            ? "reply"
                                                            : "replies"}
                                                        </>
                                                      )}
                                                    </div>
                                                  </button>
                                                )}
                                              </div>
                                            )}
                                          {/* Reply Form */}
                                          {replyingTo ===
                                            comment.comment_id && (
                                            <div className="mt-3 ml-2 pl-4 border-l-2 border-gray-200">
                                              <form
                                                onSubmit={(e) =>
                                                  handleReplySubmit(
                                                    e,
                                                    comment.comment_id,
                                                    comment.comment_post_id
                                                  )
                                                }
                                                className="flex gap-2 items-start"
                                              >
                                                {currentUser.profile_image ? (
                                                  <img
                                                    src={
                                                      currentUser.profile_image
                                                    }
                                                    alt="user"
                                                    className="w-8 h-8 rounded-full object-cover"
                                                  />
                                                ) : (
                                                  <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-sm">
                                                    {currentUser.name
                                                      ?.charAt(0)
                                                      .toUpperCase()}
                                                  </div>
                                                )}
                                                <div className="flex-1 flex flex-col">
                                                  <div className="flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
                                                    <input
                                                      type="text"
                                                      value={replyText}
                                                      onChange={(e) =>
                                                        setReplyText(
                                                          e.target.value
                                                        )
                                                      }
                                                      placeholder="Add a comment..."
                                                      className="flex-1 outline-none bg-transparent"
                                                    />
                                                    <div className="relative flex items-center gap-2">
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          setShowReplyEmojiPicker(
                                                            !showEmojiPicker
                                                          )
                                                        }
                                                        className="text-gray-500 hover:text-gray-700"
                                                      >
                                                        😊
                                                      </button>
                                                      {showReplyEmojiPicker && (
                                                        <EmojiPickerWrapper
                                                          onEmojiSelect={(
                                                            emoji
                                                          ) =>
                                                            setReplyText(
                                                              (prev) =>
                                                                prev + emoji
                                                            )
                                                          }
                                                          onClose={() =>
                                                            setShowReplyEmojiPicker(
                                                              false
                                                            )
                                                          }
                                                          positionClass="absolute bottom-16 right-0"
                                                        />
                                                      )}
                                                    </div>
                                                  </div>
                                                  <div className="flex justify-end mt-2">
                                                    <button
                                                      type="button"
                                                      onClick={() =>
                                                        setReplyingTo(null)
                                                      }
                                                      className="text-gray-600 text-sm px-3 py-1 rounded-md hover:bg-gray-100 mr-2"
                                                    >
                                                      Cancel
                                                    </button>
                                                    <button
                                                      type="submit"
                                                      disabled={
                                                        !replyText.trim()
                                                      }
                                                      className="bg-blue-600 text-white text-sm px-3 py-1 rounded-md hover:bg-blue-700 disabled:bg-blue-300"
                                                    >
                                                      Post
                                                    </button>
                                                  </div>
                                                </div>
                                              </form>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    ))}

                                  {comments.length > 2 && (
                                    <div className="pt-2">
                                      <button
                                        onClick={() =>
                                          setShowAllComments(!showAllComments)
                                        }
                                        className="w-full text-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
                                      >
                                        <div className="inline-flex items-center px-4 py-1.5 rounded-full hover:bg-gray-100">
                                          {showAllComments ? (
                                            <>
                                              <MdKeyboardArrowUp className="mr-1 text-lg" />
                                              Show fewer comments
                                            </>
                                          ) : (
                                            <>
                                              <MdKeyboardArrowDown className="mr-1 text-lg" />
                                              Show {comments.length - 2} more{" "}
                                              {comments.length - 2 === 1
                                                ? "comment"
                                                : "comments"}
                                            </>
                                          )}
                                        </div>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "networking" && (
                  <div className="bg-white shadow-lg rounded-lg mt-5 p-5">
                    <h3 className="text-xl font-normal">
                      {eventData.attendee_count || 0} attendee
                      {eventData.attendee_count !== 1 ? "s" : ""}
                    </h3>
                    {(attendees || []).length > 0 ? (
                      attendees.map((attendee, index) => (
                        <div
                          key={index}
                          className="flex items-center space-x-3 mt-2"
                        >
                          <div className="w-10 h-10 bg-gray-300 rounded-full">
                            {attendee.profile ? (
                              <img
                                src={attendee.profile}
                                alt={attendee.name}
                                className="w-full h-full object-cover rounded-full"
                              />
                            ) : (
                              <div className="w-10 h-10 bg-blue-500 text-white font-bold rounded-full flex items-center justify-center">
                                {attendee.name.charAt(0).toUpperCase()}
                              </div>
                            )}
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900">
                              {attendee.name}{" "}
                              {attendee.is_host && (
                                <span className="text-gray-600 text-sm bg-gray-100 px-2 py-1 rounded-sm">
                                  Host
                                </span>
                              )}
                            </h4>
                            <p className="text-sm text-gray-600">
                              {attendee.headline}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-600 mt-2">No attendees listed.</p>
                    )}
                  </div>
                )}

                {activeTab === "analytics" && (
                  <div className="bg-white shadow-lg rounded-lg mt-5 p-5">
                    <h3 className="text-xl font-semibold">Analytics</h3>
                    <p>
                      See insights on attendees, discussions, and engagement
                      metrics.
                    </p>
                  </div>
                )}
              </div>
              {showAttendeeModal && (
                <ManageAttendeesModal
                  isOpen={showAttendeeModal}
                  onClose={() => setShowAttendeeModal(false)}
                  connection={connections}
                  invitedEventUsers={invitedEventUsers}
                  eventAttendeeUsers={eventAttendeeUsers}
                  slug={slug}
                  getInvitedEventUsers={getInvitedEventUsers}
                />
              )}
              {showConnectionModal && (
                <InviteEventConnectionModal
                  isOpen={showConnectionModal}
                  onClose={() => setShowConnectionModal(false)}
                  connection={connections}
                  slug={slug}
                  getConnections={getConnections}
                  getInvitedEventUsers={getInvitedEventUsers}
                />
              )}
            </div>

            <div className="w-full lg:w-1/4"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default EventDetails;
